import { useSearchParams } from "react-router-dom";
import { PREVIOUS_ORDERS } from "../../../constants/order";
import PreviousOrdersDropdown from "./PreviousOrdersDropdown/PreviousOrdersDropdown";
import VoiceOrders from "./VoiceOrders/VoiceOrders";
import NormalOrders from "./NormalOrders/NormalOrders";
import classes from "./PreviousOrders.module.css";

const PreviousOrders = () => {
  const [searchParams] = useSearchParams();

  let content;
  switch (searchParams.get("type")) {
    case PREVIOUS_ORDERS.VOICE:
      content = <VoiceOrders />;
      break;
    default:
      content = <NormalOrders />;
  }

  return (
    <div className={classes["previous-orders"]}>
      <PreviousOrdersDropdown />
      {content}
    </div>
  );
};

export default PreviousOrders;
